import { render, staticRenderFns } from "./KyyAppModalStandardOrder.vue?vue&type=template&id=53e1bce5&"
import script from "./KyyAppModalStandardOrder.vue?vue&type=script&lang=js&"
export * from "./KyyAppModalStandardOrder.vue?vue&type=script&lang=js&"
import style0 from "./KyyAppModalStandardOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports